import {
  BsCalendar,
  BsCalendarFill,
  BsClipboard2Check,
  BsClipboard2CheckFill,
  BsClock,
  BsClockFill,
  BsPerson,
  BsPersonFill,
} from "react-icons/bs";
import { useSafeArea } from "../../capacitor";
import "./teacher-portal-bottom-menu.css";

const MenuItems = [
  {
    name: "Calendar",
    id: "calendar",
    selectedIcon: BsCalendarFill,
    unselectedIcon: BsCalendar,
  },
  {
    name: "Timesheets",
    id: "timesheets",
    selectedIcon: BsClipboard2CheckFill,
    unselectedIcon: BsClipboard2Check,
  },
  {
    name: "Availability",
    id: "availability",
    selectedIcon: BsClockFill,
    unselectedIcon: BsClock,
  },
  {
    name: "Profile",
    id: "profile",
    selectedIcon: BsPersonFill,
    unselectedIcon: BsPerson,
  },
];

const TeacherPortalBottomMenu = ({
  bottomMenuView,
  setBottomMenuView,
  userData,
}) => {
  const iconProps = {
    size: 25,
    color: "#ffffff",
  };
  const visibleItems = MenuItems.filter(
    (item) =>
      item.id !== "calendar" ||
      userData.School === "psma" ||
      userData.School === "tem" ||
      userData.School === "den" ||
      userData.School === "tul" ||
      userData.School === "mor" ||
      userData.School === "tma" ||
      userData.School === "lsma" ||
      userData.School === "mma"
  );

  const insets = useSafeArea();

  return (
    <div
      className="teacher-portal-bottom-menu"
      style={{ paddingBottom: insets?.bottom + 5 }}
    >
      {visibleItems.map((item) => {
        const isSelected = bottomMenuView === item.id;
        return (
          <div
            className="teacher-portal-bottom-menu__item"
            onClick={() => setBottomMenuView(item.id)}
            key={item.id}
          >
            <div className="teacher-portal-bottom-menu__item__icon">
              {isSelected
                ? item.selectedIcon(iconProps)
                : item.unselectedIcon(iconProps)}
            </div>
            <div
              className={`teacher-portal-bottom-menu__item__name ${
                isSelected && "teacher-portal-bottom-menu__item__name--selected"
              }`}
            >
              {item.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default TeacherPortalBottomMenu;
